import { Either, getOrElse } from 'fp-ts/lib/Either';

/**
 * Extrapolate the right value or use the fallback.
 */
export const getWithDefault = <L, R>(either: Either<L, R>, fallback: R): R => {
  return getOrElse(() => fallback)(either);
};
